import { DropzoneProps } from "react-dropzone";
import { Controller } from "react-hook-form";
import Dropzone from "./Dropzone";

type DropzoneFieldProps = Omit<DropzoneProps, "onChange"> &
  Pick<
    React.ComponentProps<typeof Controller>,
    "control" | "name" | "rules"
  > & {
    files?: File[];
    error?: string;
    allowedFileExtensions?: string[];
    maxFileSize?: number;
  };

const DropzoneField = ({
  name,
  control,
  rules,
  multiple = false,
  ...rest
}: DropzoneFieldProps) => {
  return (
    <Controller
      render={({ field: { onChange } }) => (
        <Dropzone
          multiple={multiple}
          onChange={(acceptedFiles: File[]) =>
            onChange(multiple ? acceptedFiles : acceptedFiles?.[0] ?? null)
          }
          {...rest}
        />
      )}
      name={name}
      control={control}
      rules={rules}
    />
  );
};

export default DropzoneField;
